export class InvalidCredentialsError extends Error {
}

export class UserDataFetchError extends Error {
}

export class SyncAllError extends Error {
}

export class SyncAllMenuError extends Error {
}

export class OrderSyncError extends Error {
}
